<template>
    <el-row>
        <group-order-search
                :handle-re-fresh="setResponse"
                :handle-search="setResponse"
        >
         <el-col :span="1">
             <el-tag type="info" size="mini">{{ groupCrafts.length }} / {{ count }}</el-tag>
         </el-col>
        </group-order-search>

        <!-- 小组分派单 -->
        <div style="padding: 0 25px">
            <group-order-table></group-order-table>
            <next-foo
                    :handle-response="addResponse"
                    :next-url="next">
            </next-foo>
        </div>
    </el-row>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex'
    import NextFoo from "../components/NextFoo"
    import GroupOrderModify from "./GroupOrderChildren/GroupOrderModify"
    import GroupOrderSearch from "./GroupOrderChildren/GroupOrderSearch"
    import GroupOrderTable from "./GroupOrderChildren/GroupOrderTable"

    export default {
        name: "GroupOrderFinance",
        components: {GroupOrderModify, NextFoo, GroupOrderSearch, GroupOrderTable},
        data() {
            return {
                groupCraftsUrl: this.$const.craftGroupRecordUrl,
                next: '',
                count: 0,
            }
        },
        computed: {
            groupCrafts() {
                return this.groupCraftData['groupCraftArray']
            },
            ...mapGetters(['groupCraftData'])
        },
        methods: {
            loadGroupCrafts() {
                if (this.groupCrafts.length <= 0) {
                    const url = `${this.groupCraftsUrl}?finish=true&limit=20` // 分页显示
                    this.$getRequest(url)
                        .then(response => {
                            this.setResponse(response)
                        })
                }
            },
            /**
             * 将 response 的结果设置为当前的小组工艺单集合
             */
            setResponse(response) {
                this.setGroupCrafts(response.data.results)
                this._baseHandleResponse(response)
            },

            /**
             * 将 response 的结果添加到为当前的小组工艺单集合
             */
            addResponse(response) {
                this.addGroupCrafts(response.data.results)
                this._baseHandleResponse(response)
            },

            /**
             * 当返回结果的基础处理
             */
            _baseHandleResponse(response){
                this.count = response.data.count
                this.next = this.$utils.handleOrderUrl(response.data.next)
            },
            ...mapMutations(['setGroupCrafts', 'addGroupCrafts'])
        },
        created() {
            this.loadGroupCrafts()
        }
    }
</script>

<style scoped>

</style>